import React from "react";
import Avatar from "../../assets/icons/profile-user.svg";
import ProfileForm from "./_ProfileForm";
import ProfileActions from "./_ProfileActions";

const ProfileViewEdit = ({
  EditProfile,
  setEditProfile,

  SignoutUser,
  setMode,
  _,

  UserProfile,
  canChangePassword,
}) => {
  return (
    <>
      <div className="profile-img-holder">
        <img src={Avatar} alt="Winona Ryder" className="profile-img" />
      </div>
      <div className="profile-sidebar-contents">
        <h3>
          {EditProfile && (
            <>
              <i
                className="icon-omni-arrow-left"
                onClick={() => setEditProfile(!EditProfile)}
              />
              {_.Edit}
            </>
          )}{" "}
          {_.Profile}
        </h3>
        <h4>
          {!EditProfile && UserProfile.firstName
            ? `${UserProfile.firstName} ${UserProfile.surname}`
            : ""}
        </h4>
        <div className="profile-sidebar-contents-extra">
          <button
            className={
              "float-right btn-clear" +
              (EditProfile ? " omni-color-ocean-green" : "")
            }
            onClick={() => {
              setEditProfile(!EditProfile);
              if (EditProfile) UserProfile.SaveProfileDetails();
            }}
          >
            <i className={"icon-omni-" + (EditProfile ? "check" : "edit")} />
            {EditProfile ? _.Save : _.Edit} {_.Profile}
          </button>
          <h5>
            {EditProfile ? "Edit" : ""} {_.Settings}
          </h5>
          <ProfileForm
            Fields={[
              {
                name: "phoneNumber",
                label: [_.Telephone, _.Number].join(" "),
                defaultValue: UserProfile.phoneNumber,
                onChange: UserProfile.UpdateValue,
                type: "text",
              },
              {
                name: "language",
                label: [_.Language, _.Settings].join(" "),
                defaultValue: UserProfile.language,
                onChange: UserProfile.UpdateValue,
                type: "select",
                values: [
                  { Text: "English", Value: "0" },
                  { Text: "Dutch", Value: "1" },
                  { Text: "French", Value: "2" },
                  // { Text: "Polish", Value: "3" }, // Removing as this is not yet supported
                ],
              },
            ]}
            EditMode={EditProfile}
          />
        </div>
      </div>
      <ProfileActions
        {...{ SignoutUser, setMode, _, UserProfile, canChangePassword }}
      />
    </>
  );
};

export default ProfileViewEdit;
